import React from 'react'
import { useNavigate } from 'react-router-dom'
import { CheckMicAndPermissions } from '.'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { PerformAssessmentStyles } from './Style'

// עמוד עצמאי לבדיקת מיקרופון כללית בשביל המורה (לא קשור למבדק אמיתי של תלמיד).
const MicCheckPage = () => {
    const navigate = useNavigate()

    const commonValue = {
        setCurrentStep: () => navigate(-1),
        isMaleGender: true,
        isHighGrade: false,
        isTeacherCheck: true
    }

    return (
        <PerformAssessmentStyles>
            <PerformAssessmentContext.Provider value={commonValue}>
                <CheckMicAndPermissions />
            </PerformAssessmentContext.Provider>
        </PerformAssessmentStyles>
    )
}

export default MicCheckPage
